module.exports = __webpack_public_path__ + "img/service-flow-planner-2.61cac392.png";